import { SxProps } from '@mui/material'

import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  } as SxProps,

  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5)
  } as SxProps,

  sectionTitleText: {
    fontSize: '0.9375rem',
    fontWeight: 600,
    color: theme.palette.grey[800]
  } as SxProps,

  fieldsGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5)
  } as SxProps,

  fieldRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1.5)
    }
  } as SxProps,

  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.25),
    flex: 1,
    minWidth: 0
  } as SxProps,

  fieldLabelText: {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: theme.palette.grey[500],
    textTransform: 'uppercase',
    letterSpacing: '0.025em'
  } as SxProps,

  fieldValueText: {
    fontSize: '0.875rem',
    fontWeight: 400,
    color: theme.palette.grey[800],
    wordBreak: 'break-word'
  } as SxProps,

  countryWithFlag: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  } as SxProps,

  summaryTotalsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5)
  } as SxProps,

  summaryDivider: {
    borderColor: theme.palette.grey[200]
  } as SxProps,

  grandTotalLabelText: {
    fontSize: '0.75rem',
    fontWeight: 700,
    color: theme.palette.grey[800],
    textTransform: 'uppercase',
    letterSpacing: '0.025em'
  } as SxProps,

  grandTotalValueText: {
    fontSize: '0.9375rem',
    fontWeight: 700,
    color: theme.palette.primary.main
  } as SxProps,

  paymentSectionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  } as SxProps,

  paymentSectionSubtitleText: {
    fontSize: '0.8125rem',
    fontWeight: 600,
    color: theme.palette.grey[700]
  } as SxProps,

  paymentFieldsRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1.5)
    }
  } as SxProps,

  refundRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    paddingLeft: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1.5),
      paddingLeft: theme.spacing(0)
    }
  } as SxProps,

  sectionDividerContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  } as SxProps,

  sectionDivider: {
    width: '50%',
    borderColor: theme.palette.grey[200]
  } as SxProps,

  majorSectionDivider: {
    borderColor: theme.palette.grey[200],
    margin: theme.spacing(0.5, 0)
  } as SxProps,

  subtitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    width: '100%'
  } as SxProps,

  subtitleText: {
    fontSize: '0.8125rem',
    color: theme.palette.grey[500],
    fontWeight: 400
  } as SxProps,

  noDataText: {
    fontSize: '0.875rem',
    color: theme.palette.grey[400],
    fontStyle: 'italic'
  } as SxProps
}

export default styles
